import { Box } from '@mantine/core';

interface CardBrandLogoProps {
	brand: string;
	size?: number;
}

export function CardBrandLogo({ brand, size = 24 }: CardBrandLogoProps) {
	const getLogoPath = (brandName: string) => {
		const normalizedBrand = brandName.toLowerCase();

		if (
			normalizedBrand.includes('amex') ||
			normalizedBrand.includes('american express')
		) {
			return '/images/brands/amex.svg';
		}
		if (
			normalizedBrand.includes('mastercard') ||
			normalizedBrand.includes('master')
		) {
			return '/images/brands/mastercard.svg';
		}
		if (normalizedBrand.includes('visa')) {
			return '/images/brands/visa.svg';
		}

		return null;
	};

	const logoPath = getLogoPath(brand);

	if (!logoPath) {
		return null;
	}

	return (
		<Box
			component="img"
			src={logoPath}
			alt={`${brand} logo`}
			style={{
				width: size,
				height: size * 0.64, // Maintain aspect ratio
				objectFit: 'contain',
			}}
		/>
	);
}
